module.exports = __webpack_public_path__ + "img/light.b5777204.png";